import * as React from 'react'
import { SVGProps } from '../../types/svg'
import COLORS from 'styles/colors'

const defaultSize = {
  width: 30,
  height: 35,
}

function SvgComponent({ style, color = COLORS.brand.primaryDark }: SVGProps) {
  return (
    <svg style={{ ...defaultSize, ...style }} viewBox='0 0 30 35'>
      <defs>
        <style>{`.prefix__a{fill:${color}}`}</style>
      </defs>
      <path
        className='prefix__a'
        d='M29.277 9.339v-.027c-.015-.331-.025-.68-.031-1.07a3.648 3.648 0 00-3.436-3.573A14.156 14.156 0 0116.175.608l-.022-.021a2.2 2.2 0 00-2.994 0l-.022.021A14.157 14.157 0 013.5 4.669 3.648 3.648 0 00.067 8.243c-.006.387-.016.736-.031 1.069v.062c-.077 4.036-.173 9.058 1.508 13.616A17.333 17.333 0 005.7 29.468a21.753 21.753 0 008.138 4.813 2.521 2.521 0 00.334.091 2.463 2.463 0 00.968 0 2.528 2.528 0 00.335-.091 21.768 21.768 0 008.125-4.816 17.358 17.358 0 004.158-6.479c1.691-4.572 1.596-9.604 1.519-13.647zm-3.409 12.949c-1.772 4.8-5.389 8.1-11.059 10.087a.507.507 0 01-.064.017.453.453 0 01-.177 0 .5.5 0 01-.064-.017c-5.676-1.979-9.296-5.274-11.067-10.082-1.549-4.2-1.461-8.812-1.383-12.88v-.022c.016-.35.026-.716.032-1.118a1.621 1.621 0 011.529-1.587 17.721 17.721 0 006.014-1.323 15.736 15.736 0 004.9-3.293.186.186 0 01.25 0 15.742 15.742 0 004.9 3.293A17.722 17.722 0 0025.7 6.686a1.621 1.621 0 011.528 1.587c.006.4.017.77.032 1.118.075 4.072.161 8.686-1.392 12.897zm0 0'
      />
      <path
        className='prefix__a'
        d='M14.655 8.633a8.578 8.578 0 108.578 8.578 8.588 8.588 0 00-8.578-8.578zm0 15.136a6.558 6.558 0 116.558-6.558 6.566 6.566 0 01-6.558 6.558zm0 0'
      />
      <path
        className='prefix__a'
        d='M17.12 14.548l-3.984 3.984-1.078-1.081a1.01 1.01 0 10-1.428 1.428l1.8 1.8a1.01 1.01 0 001.428 0l4.7-4.7a1.01 1.01 0 10-1.428-1.428zm0 0'
      />
    </svg>
  )
}

export default SvgComponent
